window.slate = window.slate || {};
window.theme = window.theme || {};

// Track popup display
slate.popUpShown = false;

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

	/**
	 * For use when focus shifts to a container rather than a link
	 * eg for In-page links, after scroll, focus shifts to content area so that
	 * next `tab` is where user expects if focusing a link, just $link.focus();
	 *
	 * @param {JQuery} $element - The element to be acted upon
	 */
	pageLinkFocus: function($element) {
		var focusClass = 'js-focus-hidden';

		$element.first()
			.attr('tabIndex', '-1')
			.focus()
			.addClass(focusClass)
			.one('blur', callback);

		function callback() {
			$element.first()
				.removeClass(focusClass)
				.removeAttr('tabindex');
		}
	},

	/**
	 * If there's a hash in the url, focus the appropriate element
	 */
	focusHash: function() {
		var hash = window.location.hash;

		// is there a hash in the url? is it an element on the page?
		if (hash && document.getElementById(hash.slice(1))) {
			this.pageLinkFocus($(hash));
		}
	},

	/**
	 * When an in-page (url w/hash) link is clicked, focus the appropriate element
	 */
	bindInPageLinks: function() {
		$('a[href*=#]').on('click', function(evt) {
			this.pageLinkFocus($(evt.currentTarget.hash));
		}.bind(this));
	},

	/**
	 * Traps the focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	trapFocus: function(options) {
		var eventName = options.namespace
			? 'focusin.' + options.namespace
			: 'focusin';

		if (!options.$elementToFocus) {
			options.$elementToFocus = options.$container;
		}

		options.$container.attr('tabindex', '-1');
		options.$elementToFocus.focus();

		$(document).on(eventName, function(evt) {
			if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
				options.$container.focus();
			}
		});
	},

	/**
	 * Removes the trap of focus in a particular container
	 *
	 * @param {object} options - Options to be used
	 * @param {jQuery} options.$container - Container to trap focus within
	 * @param {string} options.namespace - Namespace used for new focus event handler
	 */
	removeTrapFocus: function(options) {
		var eventName = options.namespace
			? 'focusin.' + options.namespace
			: 'focusin';

		if (options.$container && options.$container.length) {
			options.$container.removeAttr('tabindex');
		}

		$(document).off(eventName);
	}
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
	
	/**
	 * Browser cookies are required to use the cart. This function checks if
	 * cookies are enabled in the browser.
	 */
	cookiesEnabled: function() {
		var cookieEnabled = navigator.cookieEnabled;

		if (!cookieEnabled){
			document.cookie = 'testcookie';
			cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
		}
		return cookieEnabled;
	}
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

	/**
	 * Return an object from an array of objects that matches the provided key and value
	 *
	 * @param {array} array - Array of objects
	 * @param {string} key - Key to match the value against
	 * @param {string} value - Value to get match of
	 */
	findInstance: function(array, key, value) {
		for (var i = 0; i < array.length; i++) {
			if (array[i][key] === value) {
				return array[i];
			}
		}
	},

	/**
	 * Remove an object from an array of objects by matching the provided key and value
	 *
	 * @param {array} array - Array of objects
	 * @param {string} key - Key to match the value against
	 * @param {string} value - Value to get match of
	 */
	removeInstance: function(array, key, value) {
		var i = array.length;
		while(i--) {
			if (array[i][key] === value) {
				array.splice(i, 1);
				break;
			}
		}

		return array;
	},

	/**
	 * _.compact from lodash
	 * Remove empty/false items from array
	 * Source: https://github.com/lodash/lodash/blob/master/compact.js
	 *
	 * @param {array} array
	 */
	compact: function(array) {
		var index = -1;
		var length = array == null ? 0 : array.length;
		var resIndex = 0;
		var result = [];

		while (++index < length) {
			var value = array[index];
			if (value) {
				result[resIndex++] = value;
			}
		}
		return result;
	},

	/**
	 * _.defaultTo from lodash
	 * Checks `value` to determine whether a default value should be returned in
	 * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	 * or `undefined`.
	 * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
	 *
	 * @param {*} value - Value to check
	 * @param {*} defaultValue - Default value
	 * @returns {*} - Returns the resolved value
	 */
	defaultTo: function(value, defaultValue) {
		return (value == null || value !== value) ? defaultValue : value
	}
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
	/**
	 * Wrap tables in a container div to make them scrollable when needed
	 *
	 * @param {object} options - Options to be used
	 * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
	 * @param {string} options.tableWrapperClass - table wrapper class name
	 */
	wrapTable: function(options) {
		var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

		options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
	},

	/**
	 * Wrap iframes in a container div to make them responsive
	 *
	 * @param {object} options - Options to be used
	 * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
	 * @param {string} options.iframeWrapperClass - class name used on the wrapping div
	 */
	wrapIframe: function(options) {
		var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

		options.$iframes.each(function() {
			// Add wrapper to make video responsive
			$(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
			
			// Re-set the src attribute on each iframe after page load
			// for Chrome's "incorrect iFrame content on 'back'" bug.
			// https://code.google.com/p/chromium/issues/detail?id=395791
			// Need to specifically target video and admin bar
			this.src = this.src;
		});
	}
};

slate.Sections = function Sections() {
	this.constructors = {};
	this.instances = [];

	$(document)
		.on('shopify:section:load', this._onSectionLoad.bind(this))
		.on('shopify:section:unload', this._onSectionUnload.bind(this))
		.on('shopify:section:select', this._onSelect.bind(this))
		.on('shopify:section:deselect', this._onDeselect.bind(this))
		.on('shopify:section:reorder', this._onReorder.bind(this))
		.on('shopify:block:select', this._onBlockSelect.bind(this))
		.on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
	_createInstance: function(container, constructor) {
		var $container = $(container);
		var id = $container.attr('data-section-id');
		var type = $container.attr('data-section-type');

		constructor = constructor || this.constructors[type];

		if (typeof constructor === 'undefined') {
			return;
		}

		var instance = $.extend(new constructor(container), {
			id: id,
			type: type,
			container: container
		});

		this.instances.push(instance);
	},

	_onSectionLoad: function(evt) {
		var container = $('[data-section-id]', evt.target)[0];
		if (container) {
			this._createInstance(container);
		}
	},

	_onSectionUnload: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (!instance) {
			return;
		}

		if (typeof instance.onUnload === 'function') {
			instance.onUnload(evt);
		}

		this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
	},

	_onSelect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onSelect === 'function') {
			instance.onSelect(evt);
		}
	},

	_onDeselect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onDeselect === 'function') {
			instance.onDeselect(evt);
		}
	},

	_onReorder: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onReorder === 'function') {
			instance.onReorder(evt);
		}
	},

	_onBlockSelect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onBlockSelect === 'function') {
			instance.onBlockSelect(evt);
		}
	},

	_onBlockDeselect: function(evt) {
		var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

		if (instance && typeof instance.onBlockDeselect === 'function') {
			instance.onBlockDeselect(evt);
		}
	},

	register: function(type, constructor) {
		this.constructors[type] = constructor;

		$('[data-section-type=' + type + ']').each(function(index, container) {
			this._createInstance(container, constructor);
		}.bind(this));
	}
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
	var moneyFormat = '${{amount}}';

	/**
	 * Format money values based on your shop currency settings
	 * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
	 * or 3.00 dollars
	 * @param  {String} format - shop money_format setting
	 * @return {String} value - formatted value
	 */
	function formatMoney(cents, format) {
		if (typeof cents === 'string') {
			cents = cents.replace('.', '');
		}
		var value = '';
		var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		var formatString = (format || moneyFormat);

		function formatWithDelimiters(number, precision, thousands, decimal) {
			precision = slate.utils.defaultTo(precision, 2);
			thousands = slate.utils.defaultTo(thousands, ',');
			decimal = slate.utils.defaultTo(decimal, '.');

			if (isNaN(number) || number == null) {
				return 0;
			}

			number = (number / 100.0).toFixed(precision);

			var parts = number.split('.');
			var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
			var centsAmount = parts[1] ? (decimal + parts[1]) : '';

			return dollarsAmount + centsAmount;
		}

		switch (formatString.match(placeholderRegex)[1]) {
			case 'amount':
				value = formatWithDelimiters(cents, 2);
				break;
			case 'amount_no_decimals':
				value = formatWithDelimiters(cents, 0);
				break;
			case 'amount_with_space_separator':
				value = formatWithDelimiters(cents, 2, ' ', '.');
				break;
			case 'amount_no_decimals_with_comma_separator':
				value = formatWithDelimiters(cents, 0, ',', '.');
				break;
			case 'amount_no_decimals_with_space_separator':
				value = formatWithDelimiters(cents, 0, ' ');
				break;
		}

		return formatString.replace(placeholderRegex, value);
	}

	return {
		formatMoney: formatMoney
	};
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

	/**
	 * Preloads an image in memory and uses the browsers cache to store it until needed.
	 *
	 * @param {Array} images - A list of image urls
	 * @param {String} size - A shopify image size attribute
	 */

	function preload(images, size) {
		if (typeof images === 'string') {
			images = [images];
		}

		for (var i = 0; i < images.length; i++) {
			var image = images[i];
			this.loadImage(this.getSizedImageUrl(image, size));
		}
	}

	/**
	 * Loads and caches an image in the browsers cache.
	 * @param {string} path - An image url
	 */
	function loadImage(path) {
		new Image().src = path;
	}

	/**
	 * Find the Shopify image attribute size
	 *
	 * @param {string} src
	 * @returns {null}
	 */
	function imageSize(src) {
		var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

		if (match) {
			return match[1];
		} else {
			return null;
		}
	}

	/**
	 * Adds a Shopify size attribute to a URL
	 *
	 * @param src
	 * @param size
	 * @returns {*}
	 */
	function getSizedImageUrl(src, size) {
		if (size === null) {
			return src;
		}

		if (size === 'master') {
			return this.removeProtocol(src);
		}

		var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
		var match_asset = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?\d+)?$/i);

		if (match) {
			var prefix = src.split(match[0]);
			var suffix = match[0];

			return this.removeProtocol(prefix[0] + '_' + size + suffix);
		} else if(match_asset) {
			var prefix = src.split(match_asset[0]);
			var suffix = match_asset[0];

			return this.removeProtocol(prefix[0] + '_' + size + suffix);
		} else {
			return null;
		}
	}

	function removeProtocol(path) {
		return path.replace(/http(s)?:/, '');
	}

	return {
		preload: preload,
		loadImage: loadImage,
		imageSize: imageSize,
		getSizedImageUrl: getSizedImageUrl,
		removeProtocol: removeProtocol
	};
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

	/**
	 * Variant constructor
	 *
	 * @param {object} options - Settings from `product.js`
	 */
	function Variants(options) {
		this.$container = options.$container;
		this.product = options.product;
		this.singleOptionSelector = options.singleOptionSelector;
		this.originalSelectorId = options.originalSelectorId;
		this.enableHistoryState = options.enableHistoryState;
		this.currentVariant = this._getVariantFromOptions();

		$(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
	}

	Variants.prototype = $.extend({}, Variants.prototype, {

		/**
		 * Get the currently selected options from add-to-cart form. Works with all
		 * form input elements.
		 *
		 * @return {array} options - Values of currently selected variants
		 */
		_getCurrentOptions: function() {
			var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
				var $element = $(element);
				var type = $element.attr('type');
				var currentOption = {};

				if (type === 'radio' || type === 'checkbox') {
					if ($element[0].checked) {
						currentOption.value = $element.val();
						currentOption.index = $element.data('index');

						return currentOption;
					} else {
						return false;
					}
				} else {
					currentOption.value = $element.val();
					currentOption.index = $element.data('index');

					return currentOption;
				}
			});

			// remove any unchecked input values if using radio buttons or checkboxes
			currentOptions = slate.utils.compact(currentOptions);

			return currentOptions;
		},

		/**
		 * Find variant based on selected values.
		 *
		 * @param  {array} selectedValues - Values of variant inputs
		 * @return {object || undefined} found - Variant object from product.variants
		 */
		_getVariantFromOptions: function() {
			var selectedValues = this._getCurrentOptions();
			var variants = this.product.variants;
			var found = false;

			variants.forEach(function(variant) {
				var satisfied = true;

				selectedValues.forEach(function(option) {
					if (satisfied) {
						satisfied = (option.value === variant[option.index]);
					}
				});

				if (satisfied) {
					found = variant;
				}
			});

			return found || null;
		},

		/**
		 * Event handler for when a variant input changes.
		 */
		_onSelectChange: function() {
			var variant = this._getVariantFromOptions();

			this.$container.trigger({
				type: 'variantChange',
				variant: variant
			});

			if (!variant) {
				return;
			}

			this._updateMasterSelect(variant);
			this._updateImages(variant);
			this._updatePrice(variant);
			this.currentVariant = variant;

			if (this.enableHistoryState) {
				this._updateHistoryState(variant);
			}
		},

		/**
		 * Trigger event when variant image changes
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event}  variantImageChange
		 */
		_updateImages: function(variant) {
			var variantImage = variant.featured_image || {};
			var currentVariantImage = this.currentVariant.featured_image || {};

			if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
				return;
			}

			this.$container.trigger({
				type: 'variantImageChange',
				variant: variant
			});
		},

		/**
		 * Trigger event when variant price changes.
		 *
		 * @param  {object} variant - Currently selected variant
		 * @return {event} variantPriceChange
		 */
		_updatePrice: function(variant) {
			if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
				return;
			}

			this.$container.trigger({
				type: 'variantPriceChange',
				variant: variant
			});
		},

		/**
		 * Update history state for product deeplinking
		 *
		 * @param {object} variant - Currently selected variant
		 */
		_updateHistoryState: function(variant) {
			if (!history.replaceState || !variant) {
				return;
			}

			var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
			window.history.replaceState({path: newurl}, '', newurl);
		},

		/**
		 * Update hidden master select of variant change
		 *
		 * @param {object} variant - Currently selected variant
		 */
		_updateMasterSelect: function(variant) {
			$(this.originalSelectorId, this.$container)[0].value = variant.id;
		}
	});

	return Variants;
})();

slate.LibraryLoader = (function() {
	var types = {
		link: 'link',
		script: 'script'
	};

	var status = {
		requested: 'requested',
		loaded: 'loaded'
	};

	var cloudCdn = 'https://cdn.shopify.com/shopifycloud/';

	var libraries = {
		youtubeSdk: {
			tagId: 'youtube-sdk',
			src: 'https://www.youtube.com/iframe_api',
			type: types.script
		},
		plyrShopifyStyles: {
			tagId: 'plyr-shopify-styles',
			src: cloudCdn + 'shopify-plyr/v1.0/shopify-plyr.css',
			type: types.link
		},
		modelViewerUiStyles: {
			tagId: 'shopify-model-viewer-ui-styles',
			src: cloudCdn + 'model-viewer-ui/assets/v1.0/model-viewer-ui.css',
			type: types.link
		}
	};

	function load(libraryName, callback) {
		var library = libraries[libraryName];

		if (!library) return;
		if (library.status === status.requested) return;

		callback = callback || function() {};
		if (library.status === status.loaded) {
			callback();
			return;
		}

		library.status = status.requested;

		var tag;

		switch (library.type) {
			case types.script:
				tag = createScriptTag(library, callback);
				break;
			case types.link:
				tag = createLinkTag(library, callback);
				break;
		}

		tag.id = library.tagId;
		library.element = tag;

		var firstScriptTag = document.getElementsByTagName(library.type)[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}

	function createScriptTag(library, callback) {
		var tag = document.createElement('script');
		tag.src = library.src;
		tag.addEventListener('load', function() {
			library.status = status.loaded;
			callback();
		});
		return tag;
	}

	function createLinkTag(library, callback) {
		var tag = document.createElement('link');
		tag.href = library.src;
		tag.rel = 'stylesheet';
		tag.type = 'text/css';
		tag.addEventListener('load', function() {
			library.status = status.loaded;
			callback();
		});
		return tag;
	}

	return {
		load: load
	};
})();


/*================ Sections ================*/
theme.Slideshow = (function() {
	/**
	 * Slideshow section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function Slideshow(container) {
		this.$container = $(container);
		var sectionId = this.$container.attr('data-section-id');

		// Only run if slideshow found
		if(this.$container.find('.main-slideshow').length) {
			var $mainSlideshow = this.$container.find('.main-slideshow');

			$mainSlideshow.slick({
				arrows: false,
				dots: true,
				fade: true,
				waitForAnimate: false,
				adaptiveHeight: true,
				autoplay: $mainSlideshow.data('autoplay'),
				pauseOnHover: false,
				rows: 0
			});
		}
	}

	Slideshow.prototype = $.extend({}, Slideshow.prototype, {
		onSelect: function(event) {
			// Reinitialize slideshow height (the adaptiveHeight variable doesn't work properly in the admin)
			var $mainSlideshow = $(event.target).find('.main-slideshow');
			$mainSlideshow.slick('resize');
		},
		onBlockSelect: function(event) {
			var $slide = $(event.target),
			$mainSlideshow = $slide.closest('.main-slideshow'),
			slideIndex = $slide.data('index');

			// Go to selected slide, pause autoplay
			$mainSlideshow.slick('slickGoTo', slideIndex);
			$mainSlideshow.slick('slickPause');
		},
		onBlockDeselect: function(event) {
			var $slide = $(event.target),
			$mainSlideshow = $slide.closest('.main-slideshow');

			// Resume autoplay
			if($mainSlideshow.hasClass('autoplay-slideshow')) {
				$mainSlideshow.slick('slickPlay');
			}
		}
	});

	return Slideshow;
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
	 * @namespace product
 */

theme.Product = (function() {

	var selectors = {
		addToCart: '[data-add-to-cart]',
		addToCartText: '[data-add-to-cart-text]',
		comparePrice: '[data-compare-price]',
		comparePriceText: '[data-compare-text]',
		originalSelectorId: '[data-product-select]',
		priceWrapper: '[data-price-wrapper]',
		productFeaturedImage: '[data-product-featured-image]',
		productGallery: '[data-product-gallery]',
		productJson: '[data-product-json]',
		productPrice: '[data-product-price]',
		singleOptionSelector: '[data-single-option-selector]',
		productMediaTypeVideo: '[data-product-media-type-video]'
	};

	/**
	 * Product section constructor. Runs on page load as well as Theme Editor
	 * `section:load` events.
	 * @param {string} container - selector for the section container DOM element
	 */
	function Product(container) {
		this.$container = $(container);

		// Stop parsing if we don't have the product json script tag when loading
		// section in the Theme Editor
		if (!$(selectors.productJson).html()) {
			return;
		}

		var sectionId = this.$container.attr('data-section-id');
		this.productSingleObject = JSON.parse($(selectors.productJson).html());

		var options = {
			$container: this.$container,
			enableHistoryState: this.$container.data('enable-history-state') || false,
			singleOptionSelector: selectors.singleOptionSelector,
			originalSelectorId: selectors.originalSelectorId,
			product: this.productSingleObject
		};

		this.settings = {
			sectionId: sectionId
		};

		this.namespace = '.product';
		this.variants = new slate.Variants(options);
		this.$featuredImage = $(selectors.productFeaturedImage);

		this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
		this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

		if (this.$featuredImage.length > 0) {
			this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
			slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

			this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
		}

		this.initProductGallery();
		this.initProductVideo();
	}

	Product.prototype = $.extend({}, Product.prototype, {

		/**
		 * Updates the DOM state of the add to cart button
		 *
		 * @param {boolean} enabled - Decides whether cart is enabled or disabled
		 * @param {string} text - Updates the text notification content of the cart
		 */
		updateAddToCartState: function(evt) {
			var variant = evt.variant;

			this.renderImages(variant)

			if (variant) {
				$(selectors.priceWrapper, this.$container).removeClass('hide');
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
				$(selectors.priceWrapper, this.$container).addClass('hide');
				return;
			}

			if (variant.available) {
				$(selectors.addToCart, this.$container).prop('disabled', false);
				$(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
			} else {
				$(selectors.addToCart, this.$container).prop('disabled', true);
				$(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
			}
		},

		renderImages(variant) {
			if (!variant || variant.featured_image === null) {
				return;
			}
			$(selectors.productGallery).slick('slickGoTo', variant.featured_image.position - 1)
		},

		/**
		 * Updates the DOM with specified prices
		 *
		 * @param {string} productPrice - The current price of the product
		 * @param {string} comparePrice - The original price of the product
		 */
		updateProductPrices: function(evt) {
			var variant = evt.variant;
			var $comparePrice = $(selectors.comparePrice, this.$container);
			var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

			$(selectors.productPrice, this.$container)
				.html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

			if (variant.compare_at_price > variant.price) {
				$comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
				$compareEls.removeClass('hide');
			} else {
				$comparePrice.html('');
				$compareEls.addClass('hide');
			}
		},

		/**
		 * Updates the DOM with the specified image URL
		 *
		 * @param {string} src - Image src URL
		 */
		updateProductImage: function(evt) {
			var variant = evt.variant;
			var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

			this.$featuredImage.attr('src', sizedImgUrl);
		},

		initProductGallery: function() {
			// TODO: check if slider available
			let not_stair_nosing = $(selectors.productGallery).hasClass('stair-nosing') == false
			$(selectors.productGallery).slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: not_stair_nosing
			});
		},

		initProductVideo: function() {
			var sectionId = this.settings.sectionId;

			$(selectors.productMediaTypeVideo, this.$container).each(function() {
				var $el = $(this);
				theme.ProductVideo.init($el, sectionId);
			});
		},

		/**
		 * Event callback for Theme Editor `section:unload` event
		 */
		onUnload: function() {
			this.$container.off(this.namespace);
			theme.ProductVideo.removeSectionVideos(this.settings.sectionId);
		}
	});

	return Product;
})();

theme.ProductVideo = (function() {
	var videos = {};

	var hosts = {
		html5: 'html5',
		youtube: 'youtube'
	};

	var selectors = {
		productMediaWrapper: '[data-product-single-media-wrapper]'
	};

	var attributes = {
		enableVideoLooping: 'enable-video-looping',
		videoId: 'video-id'
	};

	function init(videoContainer, sectionId) {
		if (!videoContainer.length) {
			return;
		}

		var videoElement = videoContainer.find('iframe, video')[0];
		var mediaId = videoContainer.data('mediaId');

		if (!videoElement) {
			return;
		}

		videos[mediaId] = {
			mediaId: mediaId,
			sectionId: sectionId,
			host: hostFromVideoElement(videoElement),
			container: videoContainer,
			element: videoElement,
			ready: function() {
				createPlayer(this);
			}
		};

		var video = videos[mediaId];

		switch (video.host) {
			case hosts.html5:
				window.Shopify.loadFeatures([
					{
						name: 'video-ui',
						version: '1.0',
						onLoad: setupPlyrVideos
					}
				]);
				slate.LibraryLoader.load('plyrShopifyStyles');
				break;
			case hosts.youtube:
				slate.LibraryLoader.load('youtubeSdk', setupYouTubeVideos);
				break;
		}
	}

	function setupPlyrVideos(errors) {
		if (errors) {
			fallbackToNativeVideo();
			return;
		}

		loadVideos(hosts.html5);
	}

	function setupYouTubeVideos() {
		if (!window.YT.Player) return;

		loadVideos(hosts.youtube);
	}

	function createPlayer(video) {
		if (video.player) {
			return;
		}

		var productMediaWrapper = video.container.closest(
			selectors.productMediaWrapper
		);
		var enableLooping = productMediaWrapper.data(attributes.enableVideoLooping);

		switch (video.host) {
			case hosts.html5:
				// eslint-disable-next-line no-undef
				video.player = new Shopify.Plyr(video.element, {
					loop: { active: enableLooping }
				});
				break;
			case hosts.youtube:
				var videoId = productMediaWrapper.data(attributes.videoId);

				video.player = new YT.Player(video.element, {
					videoId: videoId,
					events: {
						onStateChange: function(event) {
							if (event.data === 0 && enableLooping) event.target.seekTo(0);
						}
					}
				});
				break;
		}

		productMediaWrapper.on('mediaHidden xrLaunch', function() {
			if (!video.player) return;

			if (video.host === hosts.html5) {
				video.player.pause();
			}

			if (video.host === hosts.youtube && video.player.pauseVideo) {
				video.player.pauseVideo();
			}
		});

		productMediaWrapper.on('mediaVisible', function() {
			if(Modernizr.touchevents) return;
			if (!video.player) return;

			if (video.host === hosts.html5) {
				video.player.play();
			}

			if (video.host === hosts.youtube && video.player.playVideo) {
				video.player.playVideo();
			}
		});
	}

	function hostFromVideoElement(video) {
		if (video.tagName === 'VIDEO') {
			return hosts.html5;
		}

		if (video.tagName === 'IFRAME') {
			if (
				/^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(
					video.src
				)
			) {
				return hosts.youtube;
			}
		}
		return null;
	}

	function loadVideos(host) {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var video = videos[key];
				if (video.host === host) {
					video.ready();
				}
			}
		}
	}

	function fallbackToNativeVideo() {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var video = videos[key];

				if (video.nativeVideo) continue;

				if (video.host === hosts.html5) {
					video.element.setAttribute('controls', 'controls');
					video.nativeVideo = true;
				}
			}
		}
	}

	function removeSectionVideos(sectionId) {
		for (var key in videos) {
			if (videos.hasOwnProperty(key)) {
				var video = videos[key];

				if (video.sectionId === sectionId) {
					if (video.player) video.player.destroy();
					delete videos[key];
				}
			}
		}
	}

	return {
		init: init,
		hosts: hosts,
		loadVideos: loadVideos,
		removeSectionVideos: removeSectionVideos
	};
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
	var $newAddressForm = $('#AddressNewForm');

	if (!$newAddressForm.length) {
		return;
	}

	// Initialize observers on address selectors, defined in shopify_common.js
	if (Shopify) {
		new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
			hideElement: 'AddressProvinceContainerNew'
		});
	}

	// Initialize each edit form's country/province selector
	$('.address-country-option').each(function() {
		var formId = $(this).data('form-id');
		var countrySelector = 'AddressCountry_' + formId;
		var provinceSelector = 'AddressProvince_' + formId;
		var containerSelector = 'AddressProvinceContainer_' + formId;

		new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
			hideElement: containerSelector
		});
	});

	// Toggle new/edit address forms
	$('.address-new-toggle').on('click', function(e) {
		e.preventDefault();
		
		$newAddressForm.toggleClass('hide');
	});

	$('.address-edit-toggle').on('click', function(e) {
		var formId = $(this).data('form-id');

		e.preventDefault();

		$('#EditAddress_' + formId).toggleClass('hide');
	});

	$('.address-delete').on('click', function(e) {
		var $el = $(this);
		var formId = $el.data('form-id');
		var confirmMessage = $el.data('confirm-message');

		e.preventDefault();

		if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
			Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
		}
	});
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
	var config = {
		recoverPasswordForm: '#RecoverPassword',
		hideRecoverPasswordLink: '#HideRecoverPasswordLink'
	};

	if (!$(config.recoverPasswordForm).length) {
		return;
	}

	checkUrlHash();
	resetPasswordSuccess();

	$(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
	$(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

	function onShowHidePasswordForm(evt) {
		evt.preventDefault();
		toggleRecoverPasswordForm();
	}

	function checkUrlHash() {
		var hash = window.location.hash;

		// Allow deep linking to recover password form
		if (hash === '#recover') {
			toggleRecoverPasswordForm();
		}
	}

	/**
	 *  Show/Hide recover password form
	 */
	function toggleRecoverPasswordForm() {
		$('#RecoverPasswordForm').toggleClass('hide');
		$('#CustomerLoginForm').toggleClass('hide');
	}

	/**
	 *  Show reset password success message
	 */
	function resetPasswordSuccess() {
		var $formState = $('.reset-password-success');

		// check if reset password form was successfully submited.
		if (!$formState.length) {
			return;
		}

		// show success message
		$('#ResetSuccess').removeClass('hide');
	}
})();


$(document).ready(function() {
	var sections = new slate.Sections(),
	$html = $('html'),
	$body = $('body'),
	$allPopups = $('.popup'),
	$overlay = $('.overlay'),
	$mediaQuery = $('.mq'),
	$mainMenuItems = $('.main-nav .site-nav > li.site-nav--has-submenu'),
	$submenus = $('.site-nav__submenu'),
	$mobileNav = $('.mobile-nav'),
	$toggleNav = $('button.toggle-nav'),
	$toggleSearch = $('a.toggle-search'),
	$slideOutSearch = $('.slide-out-search'),
	browserWidth = 'small',
	menuTimer;

	sections.register('slideshow', theme.Slideshow);
	sections.register('product', theme.Product);

	// Common a11y fixes
	slate.a11y.pageLinkFocus($(window.location.hash));

	$('.in-page-link').on('click', function(evt) {
		slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
	});

	// Target tables to make them scrollable
	var tableSelectors = '.rte table';

	slate.rte.wrapTable({
		$tables: $(tableSelectors),
		tableWrapperClass: 'rte__table-wrapper',
	});

	// Target iframes to make them responsive
	var iframeSelectors =
		'.rte iframe[src*="youtube.com/embed"],' +
		'.rte iframe[src*="player.vimeo"]';

	slate.rte.wrapIframe({
		$iframes: $(iframeSelectors),
		iframeWrapperClass: 'rte__video-wrapper'
	});

	// Apply a specific class to the html element for browser support of cookies.
	if (slate.cart.cookiesEnabled()) {
		document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
	}

	function checkMediaQuery() {
		if($mediaQuery.width() > 6) {
			browserWidth = 'xxxxlarge';
		} else if($mediaQuery.width() > 5) {
			browserWidth = 'xxxlarge';
		} else if($mediaQuery.width() > 4) {
			browserWidth = 'xxlarge';
		} else if($mediaQuery.width() > 3) {
			browserWidth = 'xlarge';
		} else if($mediaQuery.width() > 2) {
			browserWidth = 'large';
		} else if($mediaQuery.width() > 1) {
			browserWidth = 'medium';
		} else {
			browserWidth = 'small';
		}
	}
	checkMediaQuery();

	// Show/hide dropdown menus on desktop
	$mainMenuItems.on('mouseenter touchstart', function(e) {
		checkMediaQuery();
		// Only run on desktop
		if(browserWidth == 'xxxlarge' || browserWidth == 'xxxxlarge') {
			var $this = $(this);
			$this.addClass('active');
			$mainMenuItems.not($this).removeClass('active');
			$slideOutSearch.removeClass('shown');
			clearTimeout(menuTimer);
		}
	}).on('mouseleave', function(e) {
		checkMediaQuery();
		// Only run on desktop
		if(browserWidth == 'xxxlarge' || browserWidth == 'xxxxlarge') {
			var $this = $(this);
			clearTimeout(menuTimer);
			menuTimer = setTimeout(function() {
				$this.removeClass('active');
			}, 250);
		}
	});

	// Show/hide main nav panel on mobile
	$toggleNav.on('click', function(e) {
		e.preventDefault();
		e.stopPropagation(); // Don't count this as a body click because it will close the nav
		$html.toggleClass('mobile-nav-shown');
		$slideOutSearch.removeClass('shown');
	});

	// Show/hide dropdown menus on mobile
	$('li.toggle-nav-mobile > a').on('click', function(e) {
		checkMediaQuery();
		// Only run on mobile
		if(!(browserWidth == 'xxxlarge' || browserWidth == 'xxxxlarge')) {
			e.preventDefault();
			var $submenuParent = $(this).parent();
			$submenuParent.toggleClass('active');
			$('li.toggle-nav-mobile').not($submenuParent).removeClass('active');
		}
	});

	// Toggle search
	$toggleSearch.on('click', function(e) {
		e.preventDefault();
		e.stopPropagation(); // Don't count this as a body click because it will close the search
		$slideOutSearch.toggleClass('shown').find('input').focus();
		$html.removeClass('mobile-nav-shown');
		$mainMenuItems.removeClass('active');
	});

	// Close popups on button click
	$allPopups.on('click', 'a.close', function(e) {
		e.preventDefault();

		$html.removeClass('popup-shown');
		$allPopups.removeClass('shown');
		$overlay.removeClass('shown');
		slate.popUpShown = false;
	});

	// Close popups on overlay click
	$body.on('click', '.overlay', function() {
		if(slate.popUpShown) {
			$html.removeClass('popup-shown');
			$allPopups.removeClass('shown');
			$overlay.removeClass('shown');
			slate.popUpShown = false;
		}
	});

	// Close popups on escape key press
	$(document).on('keydown', function(e) {
		// If escape key pressed
		if(e.keyCode == 27) {
			if(slate.popUpShown) {
				$html.removeClass('popup-shown');
				$allPopups.removeClass('shown');
				$overlay.removeClass('shown');
				slate.popUpShown = false;
			}
		}
	});

	// Hide dropdowns on body click
	$body.on('click touchstart', function(e) {
		// Don't close slide out search on clicks inside it or on toggle icon click
		if(!($(e.target).closest($slideOutSearch).length || $(e.target).closest($toggleSearch).length)) {
			$slideOutSearch.removeClass('shown');
		}

		checkMediaQuery();
		// Only run on desktop
		if(browserWidth == 'xxxlarge' || browserWidth == 'xxxxlarge') {
			// Don't close menu on clicks inside it
			if(!$(e.target).closest($submenus).length) {
				$mainMenuItems.removeClass('active');
			}
		// Only run on mobile
		} else {
			// Don't close mobile nav on clicks inside it or on toggle icon click
			if(!($(e.target).closest($mobileNav).length || $(e.target).closest($toggleNav).length)) {
				$html.removeClass('mobile-nav-shown');
			}
		}

		if($body.hasClass('template-index')) {
			if(!$(e.target).closest('.featured-icon').length) {
				$('.featured-icons .featured-icon').removeClass('active');
			}
		}
	});

	/*================ AJAX Cart ================*/
	ajaxCart.init({
		showPopup: true,
		miniCart: false,
		formSelector: '.add-to-cart-form',
		cartContainer: '#cart-container',
		miniCartContainer: '#mini-cart-container',
		addToCartSelector: '[data-add-to-cart]',
		cartCountSelector: '.cart-item-count',
		cartImgSize: '200x', // Shopify size: e.g. '300x200_crop_center'
		cartImgSrcset: ['200x', '400x'], // Array of Shopify sizes (width required for srcset)
		miniCartImgSize: '80x',
		miniCartImgSrcset: ['80x', '160x'],
		popupImgSize: '200x',
		popupImgSrcset: ['200x', '400x']
	});

	/*================ Home Page ================*/
	if($body.hasClass('template-index')) {
		$('.featured-icons .featured-icon img').on('click', function(e) {
			e.stopPropagation(); // Don't count this as a body click because it will close the popup

			checkMediaQuery();
			// Only run on mobile
			if(browserWidth == 'small' || browserWidth == 'medium' || browserWidth == 'large') {
				$(this).parent().toggleClass('active').siblings().removeClass('active');
			}
		});

		$('.featured-icons a.close').on('click', function(e) {
			e.preventDefault();
			e.stopPropagation(); // Don't count this as a body click because it will close the popup
			$(this).closest('.featured-icon').removeClass('active');
		});

		// Show/hide architects hub menus on mobile
		$('.architects-hub-menu > li > a').on('click', function(e) {
			checkMediaQuery();
			// Only run on mobile
			if(browserWidth == 'small' || browserWidth == 'medium' || browserWidth == 'large') {
				e.preventDefault();
				var $submenuParent = $(this).parent();
				$submenuParent.toggleClass('active').siblings().removeClass('active');
			}
		});
	}

	/*================ Collection Page ================*/
	if($body.hasClass('template-collection')) {
	}

	/*================ Product Page ================*/
	if($body.hasClass('template-product')) {
	}

	if($body.hasClass('template-tactile-standards')) {
		const project_sliders = document.querySelectorAll('.project-slider')
		project_sliders.forEach(slider => {
			// TODO: check if slider available
    	$(slider).slick({
				infinite: true,
				arrows: false,
				slidesToShow: 2,
				slidesToScroll: 1,
				responsive: [
					{
						breakpoint: 500,
						settings: {
							slidesToShow: 1
						}
					}
				]
			});
			slider.parentNode.querySelector('.prev').addEventListener('click', function () {
				$(slider).slick('slickPrev')
			})
			slider.parentNode.querySelector('.next').addEventListener('click', function () {
				$(slider).slick('slickNext')
			})
		})
	}

	if($body.hasClass('template-projects') || $body.hasClass('template-blog')) {
		const project_sliders = document.querySelectorAll('.project-slider')
		project_sliders.forEach(slider => {
			// TODO: check if slider available
    	$(slider).slick({
				infinite: true,
				arrows: false,
				slidesToShow: 3,
				slidesToScroll: 3,
				responsive: [
					{
						breakpoint: 600,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 2
						}
					}
				]
			});
			slider.parentNode.querySelector('.prev').addEventListener('click', function () {
				$(slider).slick('slickPrev')
			})
			slider.parentNode.querySelector('.next').addEventListener('click', function () {
				$(slider).slick('slickNext')
			})
		})
	}
});

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
	theme.ProductVideo.loadVideos(theme.ProductVideo.hosts.youtube);
}
